// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1_365","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1SzuM","obliqueLine":"membershipbadge_obliqueLine__3CeNm"};